import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NewOrderComponent } from '../new-order/new-order.component';
import { OrdersComponent } from '../orders/orders.component';
import { Location } from '@angular/common';
import { ApiService } from '../../../core/services/api.service';
import { LocalService } from '../../../core/services/local.service';

const materialModules = [
  MatIconModule,
  MatButtonModule
]

const components = [
  NewOrderComponent,
  OrdersComponent
]

@Component({
  selector: 'app-locker',
  templateUrl: './locker.component.html',
  styleUrls: ['./locker.component.scss'],
  standalone: true,
  imports: [
    TranslateModule, ...materialModules, ...components
  ]
})
export class LockerComponent  implements OnInit {

  api = inject(ApiService);
  local = inject(LocalService);

  orders: any[] = [];
  menu: any;

  lockerUser: any = null;

  constructor(
    private location: Location
  ) { }

  ngOnInit() {
    const lockerUser = this.local.getData('lockerUser');
    if (lockerUser) {
      this.lockerUser = JSON.parse(lockerUser);
      this.getOrders();
    }

    this.getMenu();
  }

  back() {
    this.location.back();
  }

  getMenu() {
    this.api.getMenu().subscribe(
      data => {
        this.menu = data;
      }
    );
  }

  getOrders() {
    this.api.getLockerOrders(this.lockerUser.code).subscribe(
      data => {
        if (data.success) {
          this.orders = data.orders;
        }
      }
    );
  }

}
